import { createBaseCrudMachine } from '~/machines/base-crud';
import { MalpracticeInsurance } from '~/types';
import { API_CALLS } from './api';
import { emptyMalInsuranceForm } from './constants';
import { InsuranceSort, MalpracticeInsuranceFormValues } from './types';

export const insuranceMachine = createBaseCrudMachine<
  MalpracticeInsurance,
  MalpracticeInsuranceFormValues,
  InsuranceSort
>({
  initialForm: emptyMalInsuranceForm,
  sort: {
    sortBy: 'id',
    insurance_company: -1,
    policy_number: -1,
    effective_date: -1,
    active_flag: -1,
    id: -1,
    page: 1,
    pageSize: 100,
  },
  apiCalls: API_CALLS,
}).provide({
  actions: {
    log: () => console.log('INSURANCE - LOAD LOG ACTION triggered'),
  },
});
